import { useEffect, useState } from "react";
import { getUserCount, getUsersPage } from "../utility/getUsersPage";
import { FiChevronRight, FiChevronLeft } from "react-icons/fi";
import { IconButton } from "@mui/material";
import { BsArrowRepeat } from "react-icons/bs";

function UserList() {
  const [users, setUsers] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    total: 0,
    totalPage: 1,
    limit: 25,
  });

  async function getData() {
    const count = await getUserCount();
    const data = await getUsersPage(pagination.page, pagination.limit);
    setUsers(data);

    setPagination((prev) => ({
      ...prev,
      total: count,
      totalPage: Math.ceil(count / prev.limit),
    }));
  }

  useEffect(() => {
    getData();
  }, [pagination.page]);

  function resetfunc() {
    setPagination((prev) => ({
      ...prev,
      page: 1,
    }));
  }

  return (
    <div>
      <div className="flex justify-between pb-2 my-2 border-b items-center">
        <h2 className="font-[700] text-[14px]">Users ({pagination?.total})</h2>
        <div className="flex text-[13px] items-center">
            <h6 className="mr-2 font-[500]">
            Page {pagination.page} of {pagination.totalPage}
            </h6>

            <IconButton onClick={resetfunc}>
            <BsArrowRepeat size={16} />
            </IconButton>

            <div>
            <IconButton
                onClick={() =>
                pagination.page > 1 &&
                setPagination({ ...pagination, page: pagination.page - 1 })
                }
            >
                <FiChevronLeft
                className={`${pagination.page === 1 ? "opacity-50" : "opacity-100"}`}
                size={16}
                />
            </IconButton>

            <IconButton
                onClick={() =>
                pagination.page < pagination.totalPage &&
                setPagination({ ...pagination, page: pagination.page + 1 })
                }
            >
                <FiChevronRight
                className={`${pagination.page === pagination.totalPage ? "opacity-50" : "opacity-100"}`}
                size={16}
                />
            </IconButton>
            </div>
        </div>
      </div>

      <div className="grid md:grid-cols-6 mb-10 gap-2">
        {users.map((u) => (
          <div key={u.id} className="p-2 break-all border rounded">
            <h6 className="text-[13px]"><strong>User Id :</strong> {u.id}</h6>
            <h6 className="text-[12px]"><strong>Language :</strong> {u?.lan}</h6>
            <h6 className="text-[12px]">
              <strong>Fav : </strong>
              {u?.fav?.length > 0
                ? u?.fav.join(", ")
                : "No favourites"}
            </h6>
          </div>
        ))}
      </div>
    </div>
  );
}

export default UserList;
